import { Component, ElementRef, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { Chart } from 'chart.js';
import { catchError, EMPTY, Subject, takeUntil, tap } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-cars-flexed-on',
  templateUrl: './cars-flexed-on.component.html',
  styleUrl: './cars-flexed-on.component.scss'
})
export class CarsFlexedOnComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService) { }
  purchWithFlexPct: number;
  curPurchases: number;
  private unsubscribe$ = new Subject<void>()
  noDataAvailable: boolean = false;
  @ViewChild('canvasWrapper', { static: false }) canvasWrapper: ElementRef;

  chart: Chart<"pie", number[], string>;
  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(
      tap(buyerStats => {
        this.purchWithFlexPct = buyerStats.purchWithFlexPct;
        this.curPurchases = buyerStats.curPurchases;
        this.noDataAvailable = buyerStats.purchWithFlexPct == null || buyerStats.curPurchases === 0;
        this.dashboardService.removeDomElement('flex-no-data-available');
        if (this.noDataAvailable) {
          const noDataAvailableContainer = document.createElement('div');
          noDataAvailableContainer.id = 'flex-no-data-available';
          noDataAvailableContainer.style.cssText = 'width:100%';
          noDataAvailableContainer.innerHTML = `<div style='display: flex; font-size: 0.8rem; justify-content: center; padding-top: 4.7rem; color: #4E4E4E;'>No Data Available</div>`;
          this.canvasWrapper.nativeElement.appendChild(noDataAvailableContainer);
        } else {
          this.createChart();          
          this.dashboardService.removeDomElement('flex-no-data-available');
        }
      }),
      catchError(() => {
        this.noDataAvailable = true;
        return EMPTY;
      }),
      takeUntil(this.unsubscribe$)).subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createChart() {
    const purchasesWithFlexPct = parseFloat((this.purchWithFlexPct * 100).toFixed(1));
    const ctx = document.getElementById('cars-flexed-on-pie-chart') as HTMLCanvasElement;
    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new Chart(ctx, {
      type: "pie",
      data: {
        datasets: [
          {
            data: [purchasesWithFlexPct, 100- purchasesWithFlexPct],
            backgroundColor: ["#FBBA00", "#A6ABBD"],
          },
        ],
      },
      options: {
        radius: "100%",
        maintainAspectRatio: false,
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        layout: {
        },
        plugins: {
          title: {
            display: false,
            font: {
              size: 12,
              weight: 700,
            }
          },
          legend: {
            display: true,
            position: "bottom",
            align: "center",
            title: {
              display: true,
              color: "#4E4E4E",
              text: purchasesWithFlexPct + "%",
              padding: {
                top: 30
              },
              font: {
                size: 48,
              }
            },
            labels: {
              color: "#A6ABBD",
            },
          },
        },
      },
    });
  }
}
